import { menuGroup, menuItem } from "modules/helpers";

// components
import Lookup from "./Lookup.doc";

const components = [menuItem("<Lookup/>", "lookup", Lookup)];

// hooks
import UseLookup from "./UseLookup.doc";
import UseLookupAction from "./UseLookupAction.doc";

const hooks = [
  menuItem("useLookup", "use-lookup", UseLookup),
  menuItem("useLookupAction", "use-lookup-action", UseLookupAction),
];

// action creators
import LookupRequest from "./LookupRequest.doc";
import LookupReset from "./LookupReset.doc";
import LookupSet from "./LookupSet.doc";

const actionCreators = [
  menuItem("lookupRequest", "lookup-request", LookupRequest),
  menuItem("lookupReset", "lookup-reset", LookupReset),
  menuItem("lookupSet", "lookup-set", LookupSet),
];

// selectors
import GetLookupData from "./GetLookupData.doc";

const selectors = [menuItem("getLookupData", "get-lookup-data", GetLookupData)];

// configuration
import RegisterLookup from "./RegisterLookup.doc";
import UnregisterLookup from "./UnregisterLookup.doc";

const configuration = [
  menuItem("registerLookup", "register-lookup", RegisterLookup),
  menuItem("unregisterLookup", "unregister-lookup", UnregisterLookup),
];

export default [
  menuGroup("Components", "components", components),
  menuGroup("Hooks", "hooks", hooks),
  menuGroup("Action Creators", "action-creators", actionCreators),
  menuGroup("Selectors", "selectors", selectors),
  menuGroup("Configuration", "configuration", configuration),
];
